/**
 * @desc 财务画像-基础信息-主营业务变动
 * @author caoyx
 */
import style from '../common/formSearch.scss';
import cns from 'classnames';
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import NoData from '../../../common/noData/NoData';
import IndexContrastLine from '../common/IndexContrastLine';
import MoneyAbstractBar from '../common/MoneyAbstractBar';
import AntdTable from '../../common/AntdTable';
import AssetLiabilities from './AssetLiabilities';
import NormalReportPrompt from './NormalReportPrompt';
import Ellips from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import DataTransitPie from './DataTransitPie';
import { indexChangeExplain } from '../common/columns';
import { Table, Spin, Select, Row, Col } from 'antd';
import { commonRequest } from '../../common/commons';
import { isEmpty, isNotEmpty } from '../../../../utils/util';
import { business, importantChange, fiancialsummary, fiancialtrend } from '../../../../services/financialPicture/baseInfo';
const Option = Select.Option;

export default class BusinessChange extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabelData: [],
            titleData: [],
            indexData: {},
            indexTime: [],
            indexLoading: false,
            netProfit: {},
            loading: false,
            takingData: {},
            trendTime: [],
            trendLoading: false,
            trendData: [],
            options: [
                { name: '营业收入', value: 'bizinco' },
                { name: '净利润', value: 'netprofit' },
                { name: '资产总计', value: 'totasset' },
                { name: '加权平均净资产收益率', value: 'a20' },
                { name: '归属于上市公司股东的扣非净利润', value: 'npcut' }
            ]
        };
    }

    componentDidMount() {
        this.businessPort();
        this.fiancialsummaryPort();
        this.fiancialtrendPort();
    }

    businessPort = () => {
        this.setState({
            loading: true
        });
        business(commonRequest()).then(data => {
            data = data || [];
            this.setState({
                loading: false,
                tabelData: this.recombineData(data),
                titleData: this.titleData(data)
            });
        }).catch((e) => {
            this.setState({
                loading: false,
                tabelData: []
            });
        });
    };

    // 重新组装数据
    recombineData = (data) => {
        if(isEmpty(data)) {
            return [];
        }
        let obgYear = { name: '' }, industry = { name: '行业' },
            operat = { name: '经营范围' }, account = { name: '行业占比' }, allData = [];
        data.reverse().map((item, index) => {
            Object.assign(item, { id: index + 1 });
            obgYear['year' + index] = item.enddate;
            industry['year' + index] = item.industry;
            operat['year' + index] = item.operatescope;
            account['year' + index] = item.portion;
        });
        allData.push(obgYear, industry, operat, account);
        return allData;
    };

    titleData = (data) => {
        let title = [{
            dataIndex: 'name',
            fixed: 'left',
            width: 100
        }].concat(data.map(d => ({
            title: '',
            dataIndex: 'year' + (d.id - 1),
            width: 370,
            render: (v, d, i) => this.tableRender(v, d, i)
        })));
        return title;
    };

    // antd table render
    tableRender = (v, d, i) => {
        if ((d.name === '' && i === 0) || (d.name === '行业' && i === 1)) {
            return isEmpty(v) ? '--' : v;
        }
        if (d.name === '经营范围' && i === 2) {
            return <Ellips text={v || '--'} max={98} />;
        }
        if (d.name === '行业占比' && i === 3) {
            return isEmpty(v) ? <NoData /> : <DataTransitPie data={v} />;
        }
    };

    // 主要财务指标趋势
    fiancialsummaryPort = () => {
        const {options} = this.state;
        this.setState({
            indexLoading: true
        });
        fiancialsummary(commonRequest()).then(data => {
            this.data = data || {};
            this.setState({
                indexLoading: false,
                indexData: this.importantIndex(options[0].value),
                indexTime: this.data.enddate
            });
        }).catch(() => {
            this.setState({
                indexLoading: false
            });
        });
    };

    importantIndex = (val) => {
        const { options } = this.state;
        let data = this.data,
            option = options.find((v) => v.value === val);

        return {
            barData: [{ name: option.name, data: data[val] }],
            lineData: [{ name: option.name + '中位数', data: data['median' + val] }]
        };
    };

    // 选择不同财务指标
    handleChange = (val) => {
        this.setState({
            indexData: this.importantIndex(val)
        });
    };

    // 关键财务指标趋势对比
    fiancialtrendPort = () => {
        this.setState({
            trendLoading: true
        });
        fiancialtrend(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                trendLoading: false,
                trendData: [
                    {
                        name: '应收账款', data: data.accorece || []
                    },
                    {
                        name: '经营活动现金流增速', data: data.biznetcflow || []
                    },
                    {
                        name: '净利润', data: data.netprofit || []
                    },
                    {
                        name: '固定资产周转率', data: data.a23 || []
                    }
                ],
                trendTime: data.reportyear || [],
                takingData: {
                    name: '营业收入', data: data.bizinco || []
                }

            });
        }).catch((e) => {
            this.setState({
                trendLoading: false
            });
        });
    };

    render() {
        const {
            loading, tabelData, titleData,
            indexLoading, indexData, indexTime,
            trendLoading, trendData, trendTime, takingData, options
        } = this.state;
        return (
            <div>
                <GroupBox id="business-change" title="主营业务变动">
                    {loading ? <Spin tip="数据加载中，请稍候……" /> :
                        isNotEmpty(tabelData) ?
                            <Table
                                className="antdTable"
                                rowKey="name"
                                loading={loading}
                                pagination={false}
                                columns={titleData}
                                dataSource={tabelData}
                                scroll={{ x: 1240 }}
                                showHeader={false}
                            /> : <NoData />
                    }
                </GroupBox>
                <GroupBox id="financial-index" title="主要财务指标趋势">
                    <div className={cns('search-bar', style.formSearch)}>
                        <Select size="default" defaultValue="bizinco" onChange={this.handleChange}>
                            {options.map(item => <Option key={item.value} value={item.value}>{item.name}</Option>)}
                        </Select>
                    </div>
                    <MoneyAbstractBar
                        loading={indexLoading}
                        data={indexData}
                        enddateData={indexTime}
                        average={false}
                    />
                </GroupBox>
                <GroupBox id="index-contrast" title="关键财务指标趋势对比">
                    <Row>
                        {trendData.map(item => (
                            <Col span={11} offset={1} key={item.name}>
                                <IndexContrastLine
                                    trendLoading={trendLoading}
                                    takingData={takingData}
                                    name={item.name}
                                    data={item.data}
                                    year={trendTime}
                                />
                            </Col>
                        ))}
                    </Row>
                </GroupBox>
                <AntdTable
                    idName={'index-change-explain'}
                    title="重要指标变动说明"
                    requestApi={importantChange}
                    list={true}
                    columns={indexChangeExplain}
                />
                <AssetLiabilities />
                <NormalReportPrompt />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/BusinessChange.jsx